import { render, staticRenderFns } from "./HomeBlockEvent.vue?vue&type=template&id=6df5fd7f&name=home-block-event&"
import script from "./HomeBlockEvent.vue?vue&type=script&lang=js&"
export * from "./HomeBlockEvent.vue?vue&type=script&lang=js&"
import style0 from "./HomeBlockEvent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports